/**
 * Utility functions for WorkOS token management
 *
 * Note: WorkOS tokens are stored in HttpOnly cookies and cannot be read from JavaScript.
 * Use the router (fetchWorkosTokenStatus) to get token information.
 */

/**
 * Log auth-related events for debugging
 * @param event - Event name
 * @param details - Additional details
 */
export function logAuthEvent(event: string, details?: Record<string, unknown>) {
  const timestamp = new Date().toISOString()
  console.log(`[Auth ${timestamp}] ${event}`, details || '')
}
